import { isEmpty, each, get, toLower } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import Spinner from 'common-ui-components/dist/components/Molecules/Spinner';
import { countryCommerceConfigContract, INDIA_COUNTRY_CODE } from '../global/constants';
import { getStore } from './utils';
import API_URLS from '../constants/api/services';
import { updateSessionStorage } from './storage';

export const getBoolValue = (value = '') =>
  typeof value === 'boolean' ? value : value.toLowerCase() === 'true';

export const getCountryCommerceConfigContract = (countryResponse = {}) => {
  const result = countryCommerceConfigContract;
  each(countryCommerceConfigContract, (value, key) => {
    result[key] =
      typeof countryResponse[key] === 'string'
        ? getBoolValue(countryResponse[key])
        : countryResponse[key];
  });
  const store = getStore();
  const registeredCountry = get(store, [
    'global',
    'globalData',
    'userDetails',
    'mailingAddressCountryCode',
  ]);
  if (!isEmpty(registeredCountry) && toLower(registeredCountry) === INDIA_COUNTRY_CODE) {
    result.isGSTEnabled = true;
    result.isPOAttachmentRequired = true;
  }
  return result;
};

export const returnParsedUserDetails = userDetails => JSON.parse(userDetails) ?? {};
export const getCreatedCustomerId = async (
  userId,
  userEmail,
  firstName,
  lastName,
  sfContactId,
  countryCode,
  spCustomerId
) => {
  let response = {};
  const { salesOrg } = JSON.parse(sessionStorage.getItem('waters.userDetails'));
  if (spCustomerId === null || spCustomerId === undefined) {
    const body = JSON.stringify({
      webUserId: userId,
      email: userEmail,
      firstName,
      lastName,
      sfContactId: sfContactId || '',
      countryCode: countryCode,
    });
    const spOptions = {
      credentials: 'include',
      mode: 'cors',
      body,
      method: 'POST',
      headers: {
        salesOrg,
        'content-type': 'application/json',
      },
    };

    await window
      .fetch(API_URLS.createCustomerOnStripe, spOptions)
      .then(res => res.json())
      .then(res => {
        response = res;
      })
      .catch(error => {
        console.log('error: ', error);
        return null;
      });
    if (response.spCustomerId) {
      updateSessionStorage('waters.userDetails', 'spCustomerId', response.spCustomerId);
    }
  }
  return response.spCustomerId;
};

export const capitalizeFirstLetter = data => data && data.slice(0, 1).toUpperCase() + data.slice(1);
export const getSpPublickey = store =>
  get(
    store,
    ['global', 'globalData', 'countryData', 'SP_PUBLIC_KEY'],
    sessionStorage.getItem('SP_PUBLIC_KEY') !== 'undefined'
      ? sessionStorage.getItem('SP_PUBLIC_KEY')
      : undefined
  );

export const getStripeCardTypes = store =>
  get(
    store,
    ['global', 'globalData', 'countryData', 'allowedCardTypes'],
    sessionStorage.getItem('allowedCardTypes') !== 'undefined'
      ? sessionStorage.getItem('allowedCardTypes')
      : undefined
  );

export const getStripePaymentMethodOrder = store =>
  get(
    store,
    ['global', 'globalData', 'countryData', 'paymentMethodOrder'],
    sessionStorage.getItem('paymentMethodOrder') !== 'undefined'
      ? sessionStorage.getItem('paymentMethodOrder')
      : undefined
  );

export const getClientSecret = globalData =>
  get(globalData, ['stripeData', 'setupIntentId'], undefined);

export const getCustomerSessionClientSecret = globalData =>
  get(globalData, ['stripeData', 'customerSessionId'], undefined);

export const loader = flag => {
  let element = document.getElementById('loader');
  if (!element) {
    element = document.createElement('div');
    element.setAttribute('id', 'loader');
    document.body.appendChild(element);
  }
  const props = {
    isLoading: flag,
  };
  ReactDOM.render(<Spinner {...props} />, document.getElementById('loader'));
};
